import { AuthEntity } from '../entities/AuthEntity';

const DEFAULT_ROLE = 'admin';
export const conversationReadableRoles = new Set(['owner', 'admin', 'operator', 'senior_operator']);
export const getOperatorRole = (authEntity: AuthEntity | null) => {
  return authEntity?.operatorRoleType ?? DEFAULT_ROLE;
};
